<template>
  <v-container>
    <v-row>
      <p class="display-1">Elever</p>
    </v-row>
    <v-row>
      <div>
        <v-btn
          to="/profil/ny"
          class="mt-12"
          color="primary"
          dark
          large
          absolute
          top
          right
          fab
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-list>
          <v-list-item v-for="(profile, i) in persons" :key="i">
            <v-avatar color="grey" size="36" class="mr-2">
              <v-img
                v-if="profile.photo"
                :src="profile.photo"
                :alt="profile.firstName"
              />
              <span v-else class="white--text subtitle">{{
                initials(profile)
              }}</span>
            </v-avatar>
            <v-list-item-content>
              <v-list-item-title>
                <router-link :to="`/profil/${profile.id}`"
                  >{{ profile.firstName }} {{ profile.middleName }}
                  {{ profile.lastName }}</router-link
                >
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </v-row>
  </v-container>
</template>

<script>
export default {
  mounted() {
    this.$store.dispatch("activePersons");
  },
  methods: {
    initials(userData) {
      return userData.firstName.charAt(0) + userData.lastName.charAt(0);
    }
  },
  computed: {
    persons() {
      return this.$store.getters.profilesByFunction("7mzJwXQe4KnKOQ7Gqovb");
    }
  }
};
</script>

<style lang="scss" scoped>
#lateral .v-btn--example {
  bottom: 0;
  position: absolute;
  margin: 0 0 16px 16px;
}
</style>
